import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { NoticeboardButton, DeleteModal } from "../shared";
import {
  canConfirmDraftRemoval,
  draftRemovalNeedsTypedTitle,
} from "../../domain/notices/draftRemoval";

interface DeleteDraftModalProps {
  open: boolean;
  onClose: () => void;
  draftTitle: string | undefined;
  confirmationText: string;
  onConfirmationTextChange: (value: string) => void;
  onConfirm: () => void;
}

const DeleteDraftModal: React.FC<DeleteDraftModalProps> = ({
  open,
  onClose,
  draftTitle,
  confirmationText,
  onConfirmationTextChange,
  onConfirm,
}) => {
  const needsTypedTitle = draftRemovalNeedsTypedTitle(draftTitle);

  return (
    <DeleteModal
      open={open}
      onClose={onClose}
      title="Remove Draft"
      subtitle="This action cannot be undone"
    >
      <Typography
        variant="body1"
        sx={{ mb: 3, fontSize: "1rem", lineHeight: 1.6 }}
      >
        Are you sure you want to remove the draft{" "}
        <Typography component="span" fontWeight={600}>
          "{needsTypedTitle ? draftTitle : "Untitled Draft"}"
        </Typography>
        ? This action cannot be undone and the draft will be permanently
        removed.
      </Typography>

      {needsTypedTitle && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            To confirm removal, please type the draft title:{" "}
            <Typography component="span" fontWeight={600} color="error.main">
              {draftTitle}
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="Type the draft title to confirm"
            value={confirmationText}
            onChange={(e) => onConfirmationTextChange(e.target.value)}
            sx={{ mt: 1 }}
          />
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <NoticeboardButton
          variant="danger"
          onClick={onConfirm}
          disabled={!canConfirmDraftRemoval(draftTitle, confirmationText)}
        >
          Remove Draft
        </NoticeboardButton>
      </Box>
    </DeleteModal>
  );
};

export default DeleteDraftModal;
